/**
 * Determine if a color is a light color
 * @see https://gist.github.com/krabs-github/ec56e4f1c12cddf86ae9c551aa9d9e04
 */
export function isLightColor(color: string): boolean {
  const hexColor = +`0x${color.slice(1).replace(color.length < 5 ? /./g : "", "$&$&")}`;
  const r = hexColor >> 16;
  const g = (hexColor >> 8) & 255;
  const b = hexColor & 255;

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  // > 127.5 is 'light', <= 127.5 is 'dark'
  return hsp > 170;
}
